import React, { useState } from 'react';
import AsyncSelect from 'react-select/async';
import { useTranslate } from '../../../mixins/translate/translate';
import { fetchGet } from '../../../store/fetch';

const selectStyles = {
    menu: (styles: any) => ({ ...styles, zIndex: 999 }),
};

type ObjectSelectProps = { objectIdsToIgnore: string[]; onChange: (value: string | undefined) => void; onSubmit: () => void };

export function ObjectSelect(props: ObjectSelectProps) {
    const translate = useTranslate();
    const [hasSelectedValue, setHasSelectedValue] = useState(false);

    const loadAvailableObjects = async (input?: string) => {
        let options: { value: string; label: string }[] = [];

        if (input && input.length >= 3) {
            const url = '/api/objects';
            const result = await fetchGet(url, { objectName: input }, ['NO_DATA_AVAILABLE']);
            const items = result.json.items as { id: string; name: string }[];
            options = items
                .filter((object) => !props.objectIdsToIgnore.includes(object.id))
                .map((object) => ({ value: object.id, label: object.name }));
        }
        return options;
    };

    return (
        <div style={{ width: '500px' }}>
            <AsyncSelect
                autoFocus
                id="name"
                name="name"
                backspaceRemovesValue={false}
                isClearable={true}
                isMulti={false}
                styles={selectStyles}
                inputProps={{ autoComplete: 'off', autoCorrect: 'off', spellCheck: 'off' }}
                loadOptions={async (inputValue: any) => loadAvailableObjects(inputValue)}
                onChange={(option: any) => {
                    props.onChange(option?.value);
                    if (option?.value) {
                        setHasSelectedValue(true);
                    } else {
                        setHasSelectedValue(false);
                    }
                }}
                valueKey="value"
                labelKey="label"
                placeholder={translate('common.searchItem', translate('common.object'))}
                onKeyDown={(e: { code: string }) => {
                    if (e.code === 'Enter' && hasSelectedValue) {
                        props.onSubmit();
                    }
                }}
            />
        </div>
    );
}
